import { api } from './api'

/**
 * 리뷰 목록
 * @param {object} data - { 리뷰 }
 * @returns
 */

const getInterestInfo = data =>
  new Promise((resolve, reject) => {
    data = {
      review_token: data.review_token,
    }
    api
      .post('/api/v1/review/interestReviewInfo', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

/**
 * 댓글 등록
 * @param {object} data - { 리뷰 }
 * @returns
 */

const setCommentRegi = data =>
  new Promise((resolve, reject) => {
    data = {
      review_token: data.review_token,
      shop_idx: data.shop_idx,
      store_idx: data.store_idx,
      app_idx: data.app_idx,
      comment_history_idx: data.comment_history_idx,
      comment_use_type_code: data.comment_use_type_code,
      comment_use_yn: data.comment_use_yn,
      comment_modify_yn: data.comment_modify_yn,
      contents: data.contents,
      important_yn: data.important_yn,
    }
    api
      .post('/api/v1/review/interestCommentRegi', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

/**
 * 댓글 블라인드
 * @param {object} data - { 리뷰 }
 * @returns
 */

const setInterestBlind = data =>
  new Promise((resolve, reject) => {
    data = {
      review_token: data.review_token,
      shop_idx: data.shop_idx,
      store_idx: data.store_idx,
      app_idx: data.app_idx,
    }
    api
      .post('/api/v1/review/setReviewBlindByOwner', data)
      .then(response => {
        const resDate = response.data
        if (resDate.result_code === '00000') {
          data = { ...data, ...resDate.data }
          resolve(data)
        } else {
          data = { ...data, ...resDate.data }
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })

const interestConfig = { getInterestInfo, setCommentRegi, setInterestBlind }

export { interestConfig }
